import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/freezer/findByPage",
        method: "post",
        data
    });
}

/**
 * 初始化门店冷柜树
 */
export function FetchStoreFreezerTree() {
    return request({
        url: "/base/freezer/getStoreFreezerInfoTree",
        method: "post",
    });
}

/**
 * 保存冷柜信息
 * @param {*} data
 */
export function SaveFreezerInfo(data) {
  return request({
      url: "/base/freezer/saveFreezerInfo",
      method: "post",
      data
  });
}

/**
 * 查询单个冷柜信息
 * @param {*} data
 */
export function FindFreezerInfoById(data) {
  return request({
      url: "/base/freezer/findFreezerInfoById",
      method: "post",
      data
  });
}

/**
 * 删除冷柜信息
 * @param {*} data
 */
export function DeleteFreezerInfoByIds(data) {
  return request({
      url: "/base/freezer/deleteFreezerInfoByIds",
      method: "post",
      data
  });
}

/**
 * 根据门店获取冷柜
 * @param {*} data
 */
export function FindFreezerInfoByStoreId(data) {
  return request({
      url: "/base/freezer/findFreezerInfoByStoreId",
      method: "post",
      data
  });
}





